<template>
<span :class='validationClass'>
  <el-input ref="editor" v-if="visible" v-model="value" size="mini" :type="type" :edit="true" controls-position="right"
  @blur="endEdit()" @keyup.enter.native="endEdit()" @keyup.esc.native="cancelEdit()"
  @clearable="endEdit()" @input="checkValid"></el-input>
  <span v-else-if="$slots.content === undefined">
    {{getValueAfterCheckEmpty(data[property])}}
  </span>
  <slot name="content" v-else></slot>
</span>
</template>

<script>
import { getValueAfterCheckEmpty } from '@/utils/string';
import InputCellEditorMixin from './mixins/input-cell-editor';
// TODO: clearable 클릭 시 blur 호출되므로 일단 제거.
export default {
  name: 'WInputEditor',
  mixins: [InputCellEditorMixin],
  props: {
    type: {
      type: String,
      required: false,
    },
  },
  methods: {
    getValueAfterCheckEmpty,
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/table/cell-editor/InputEditor.vue